import { INVESTMENT_PAGE_RECEIVE, INVESTMENT_PAGE_ERROR } from "./InvestmentPage.action";
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: []
}
export const InvestmentReducer = (state = defaultState, action) => {
    switch (action.type) {
        case INVESTMENT_PAGE_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case INVESTMENT_PAGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}